/* eslint-disable prefer-destructuring */

import Immutable from 'immutable';
import _ from 'lodash';

import {
  SET_INSTITUTION_COMPLETION_DATA,
  UPDATE_SELECTED_INSTITUTION_COMPLETION_COURSE_LIST,
  START_LOADING_INSTITUTION_COMPLETION_DATA,
  FINISH_LOADING_INSTITUTION_COMPLETION_DATA,
  SET_USER_SELECTED_DATA,
  START_LOADING_CSV_DATA,
  INTERMEDIATE_LOADING_CSV_DATA,
  FINISH_LOADING_CSV_DATA,
} from './actions';

// TODO: merge this with the InstitutionAdmin reducer
export function InstitutionExtras(state = new Immutable.Map(), action = {}) {
  switch (action.type) {
    case SET_INSTITUTION_COMPLETION_DATA: {
      const institutionName = action.institutionProgressData.name;
      let newState = state.set(
        'institution',
        Immutable.fromJS(institutionName)
      );
      newState = newState.set('hasInstitutionCompletionDataLoaded', false);
      newState = newState.set('hasDataAfterMoreButtonClickLoaded', false);
      newState = newState.set('hasCsvDataLoadingStarted', false);
      newState = newState.set('csvProcessPercentage', '0%');
      newState = newState.set('hasCsvDataLoadingFinished', false);
      const instiCourses = action.institutionProgressData.courses;
      // add groups
      const groups = action.institutionProgressData.groups;
      newState = newState.set('groups', groups);
      const courses = _.map(instiCourses, (course) => {
        // TO-Do use Immutable JS directly instead of converting
        const courseObj = {};
        courseObj.path = course.path;
        courseObj.name = course.name;
        courseObj.url = course.url;
        courseObj.numEnrolled = course.numEnrolled;
        const cohorts = _.map(course.classes, (cohort) => {
          const cohortObj = {};
          cohortObj.value = cohort.path;
          cohortObj.label = cohort.path;
          cohortObj.numEnrolled = cohort.numEnrolled;
          cohortObj.checked = false;
          return cohortObj;
        });
        courseObj.classes = cohorts;
        return courseObj;
      });
      return newState.set('courses', Immutable.fromJS(courses));
    }
    case UPDATE_SELECTED_INSTITUTION_COMPLETION_COURSE_LIST: {
      const checkedCohort = action.cohort;
      const checkedState = action.isChecked;

      const prevCourseSates = state.get('courses').toJS();
      const courses = _.map(prevCourseSates, (course) => {
        const courseObj = {};
        courseObj.path = course.path;
        courseObj.name = course.name;
        courseObj.url = course.url;
        courseObj.numEnrolled = course.numEnrolled;
        const cohorts = _.map(course.classes, (cohort) => {
          const cohortObj = {};
          cohortObj.value = cohort.value;
          cohortObj.label = cohort.label;
          cohortObj.numEnrolled = cohort.numEnrolled;
          if (cohortObj.value === checkedCohort) {
            cohortObj.checked = checkedState;
          } else {
            cohortObj.checked = cohort.checked;
          }
          return cohortObj;
        });
        courseObj.classes = cohorts;
        return courseObj;
      });
      return state.set('courses', Immutable.fromJS(courses));
    }
    case SET_USER_SELECTED_DATA: {
      const userSelectedData = {};
      userSelectedData.coursePaths = action.coursePaths;
      userSelectedData.cohortPaths = action.cohortPaths;
      userSelectedData.startIndex = action.startIndex;
      userSelectedData.endIndex = action.endIndex;
      return state.set('userSelectedData', userSelectedData);
    }
    case START_LOADING_INSTITUTION_COMPLETION_DATA: {
      return state.set('hasDataAfterMoreButtonClickLoaded', false);
    }
    case FINISH_LOADING_INSTITUTION_COMPLETION_DATA: {
      let newState = state.set('hasInstitutionCompletionDataLoaded', true);
      newState = newState.set('hasDataAfterMoreButtonClickLoaded', true);
      const startIndex = action.startIndex;
      const result = action.data.result;
      if (startIndex === 0) {
        newState = newState.set(
          'totalNumberOfStudents',
          action.data.totalNumberOfStudents
        );
        newState = newState.set('institutionTableRows', result);
      } else {
        let prevInstiRows = state.get('institutionTableRows');
        prevInstiRows = prevInstiRows.concat(result);
        newState = newState.set('institutionTableRows', prevInstiRows);
      }
      return newState;
    }
    case START_LOADING_CSV_DATA: {
      const newState = state.set('csvProcessPercentage', '0%');
      return newState.set('hasCsvDataLoadingStarted', true);
    }
    case INTERMEDIATE_LOADING_CSV_DATA: {
      const endIndex = action.endIndex;
      const totalNumberOfStudents = action.totalNumberOfStudents;
      const pecentage = Math.round((endIndex / totalNumberOfStudents) * 100);
      return state.set('csvProcessPercentage', `${pecentage}%`);
    }
    case FINISH_LOADING_CSV_DATA: {
      let newState = state.set('csvProcessPercentage', '100%');
      const csvID = action.csvFileID;
      const institutionName = action.institutionName;
      const csvDownloadUrl = `/institution/admin/exportCsvStudentData/?institution=${institutionName}&csvID=${csvID}`;
      newState = newState.set('hasCsvDataLoadingStarted', false);
      newState = newState.set('hasCsvDataLoadingFinished', true);
      newState = newState.set('csvDownloadUrl', csvDownloadUrl);
      return newState;
    }
    default: {
      return state;
    }
  }
}
